import { useEffect, useState } from "react";

const useQueries = () => {
    const [queries, setQueries] = useState<any>(null);

    const fetchQueries = async () => {
        const configRes = await fetch('/queries.json');
        const config = await configRes.json();
        setQueries(config)
    }

    useEffect(() => {
        fetchQueries();
    }, [])

    return queries
}

export default useQueries;